import React, { Component } from "react";
import { producaov2 } from "../../services/apis";
import { Button, Container, Dropdown, Breadcrumb } from "semantic-ui-react";
import CarouselDragNDrop from "./CarouselDragNDrop";
import LoadScreen from "../../components/LoadScreen";
import ModalCarrosseisOrdenation from "./ModalCarrosseisOrdenation";
import ModalAdicionarCurso from "./ModalAdicionarCurso";
import "./styles.css";
import swal from "sweetalert";
import { FaThList } from "react-icons/fa";

export default class PainelCarrosseisSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carrosseis: {
        options: [],
        value: [],
      },

      cursosAreas: [
        {
          options: [],
          value: [],
          dropdown: {
            value: [],
          },
          toBeDeleted: [],
        },
      ],

      cursosIndex: 0,

      carousel: {
        index: 0,
        perPage: 4,
        size: 0,
      },

      cursoUltimoAdicionado: {
        id: "",
        id_curso: "",
        url_amigavel: "",
        title: "",
      },

      listAllCourses: [],

      isLoading: true,
    };

    this.nodeFaixa = {};
    this.nodeInputFaixa = {};
  }

  async componentDidMount() {
    await this.getCarouselArea();
    await this.getAllCursos();
    await this.getCarouselVenda();
    await this.getUltimoCursoAdicionado();
  }

  getCarouselArea = async () => {
    await producaov2
      .get("admin/carousel/area")
      .then((res) => res.data)
      .then((data) => {
        const options = data.map((carousel) => {
          return {
            key: carousel.id,
            text: `${carousel.area}`,
            value: {
              id: carousel.id,
              ordem: carousel.ordem,
            },
          };
        });

        options.sort((pos, ant) => pos.value.ordem > ant.value.ordem);

        const carrosseis = {
          value: options[0].value,
          options,
        };

        const cursosIndex = parseInt(options[0].value.id - 1);
        this.setState({ carrosseis, cursosIndex });
      });
  };

  getAllCursos = async () => {
    await producaov2
      .get("/cursos-simplelistAll")
      .then((res) => res.data)
      .then((data) => {
        const options = data.map((curso) => {
          return {
            key: curso.id,
            text: `${curso.id} - ${curso.curso}`,
            value: {
              id: curso.id.toString(),
              id_item: -1,
              ordem: 0,
              text: `${curso.id} - ${curso.curso.slice(0, 76) + " ..."}`,
              valor_carousel: "",
              url_amigavel: curso.url_amigavel,
              faixa: {
                text: "",
                color: "",
                textDisplay: "block",
                inputDisplay: "none",
              },
            },
          };
        });

        this.setState({ listAllCourses: options });

        const { cursosAreas } = this.state;
        cursosAreas.map((cursos) => {
          cursos.options = options;
        });

        this.setState({ cursosAreas });
      });
  };

  getCarouselVenda = async () => {
    await producaov2
      .get(`admin/carousel/venda`)
      .then((res) => res.data)
      .then((data) => {
        const { carrosseis, cursosAreas, cursosIndex } = this.state;
        const allOptions = cursosAreas[0].options;

        // Adiciona os cursos aos seus respectivos carrosseis

        data?.map((carousel_venda) => {
          const { curso } = carousel_venda;
          const { id_carousel_area } = carousel_venda;
          const index = parseInt(id_carousel_area) - 1;

          if (cursosAreas[index] == undefined) {
            cursosAreas[index] = {
              options: allOptions,
              value: [],
              dropdown: {
                value: [],
              },
              toBeDeleted: [],
            };
          }

          const found = cursosAreas?.[index]?.value?.includes(curso?.id);

          if (!found) {
            cursosAreas[index].value.push({
              id: curso?.id?.toString(),
              id_item: carousel_venda?.id,
              ordem: curso?.ordem,
              text: `${curso?.id} - ${curso?.curso.slice(0, 76) + " ..."}`,
              valor_carousel: carousel_venda?.valor_carousel,
              url_amigavel: curso?.url_amigavel,
              faixa: {
                text: carousel_venda?.texto_faixa,
                color: carousel_venda?.cor_faixa
                  ? carousel_venda?.cor_faixa
                  : "grey",
                textDisplay: "block",
                inputDisplay: "none",
              },
            });
          }
        });

        cursosAreas.map((cursos) => {
          cursos.options = cursos?.options?.filter((option) => {
            return !cursos?.value?.find(
              (curso) => curso?.id?.toString() == option?.key
            );
          });
        });

        const carousel = {
          size: cursosAreas?.[cursosIndex]?.value?.length,
          index: 0,
          perPage: 4,
        };

        const isLoading = false;

        this.setState({
          carrosseis,
          carousel,
          cursosAreas,
          cursosIndex,
          isLoading,
        });
      });
  };

  getUltimoCursoAdicionado = () => {
    producaov2
      .get("/ultimo_adicionado")
      .then((response) => {
        const ultimoAdicionado = response.data;

        const fullDataUltimoAdicioando = this.state.listAllCourses.filter(
          (item) => parseInt(item.key) === parseInt(ultimoAdicionado.id_curso)
        );

        this.setState({
          cursoUltimoAdicionado: {
            id: ultimoAdicionado.id,
            id_curso: ultimoAdicionado.id_curso,
            url_amigavel: fullDataUltimoAdicioando[0]?.value.url_amigavel,
            title: fullDataUltimoAdicioando[0]?.text,
          },
        });
      })
      .catch((err) => {
        console.error(`Erro - ${err}`);
      });
  };

  getDetailsCurso = (id) => {};

  changeCarrosseisIndex = (event, { id, value }) => {
    const { carrosseis, carousel, cursosAreas } = this.state;
    const cursosIndex = parseInt(value.id) - 1;

    carrosseis.value = value;

    carousel.index = 0;
    carousel.size = cursosAreas[cursosIndex].value.length;

    this.setState({ carrosseis, carousel, cursosIndex, cursosAreas });
  };

  handleSalvarClick = async () => {
    const { carrosseis, cursosIndex, cursosAreas } = this.state;
    const cursos = cursosAreas[cursosIndex];

    const carousel = cursos.value.map((curso, index) => {
      return {
        id_curso: curso.id,
        id_carousel_area: this.state["carrosseis"].value.id,
        ordem: index + 1,
        texto_faixa: curso.faixa.text,
        cor_faixa: curso.faixa.text == "" ? "" : curso.faixa.color,
        valor_carousel: curso.valor_carousel,
        ativo: true,
      };
    });

    // Reordenava os carrosseis no botao Reordenar que esta comentado
    // carrosseis.options.map(async (option) => {
    //   const id = option.value.id;
    //   const ordem = option.value.ordem;

    //   await producaov2.put(`admin/carousel/area/${id}`, { ordem });
    // });

    // const arrayID = cursos.value
    //   .filter((curso) => curso.id_item > -1)
    //   .map((curso) => curso.id_item)
    //   .concat(cursos.toBeDeleted.filter((id_item) => id_item > -1));

    // producaov2.delete(`admin/carousel/venda`, { data: { arrayID } });

    producaov2
      .post("admin/carousel/venda", { carousel })
      .then((res) => res.data)
      .then((res) => {
        cursos.value.map((curso, index) => {
          curso.id_item = res.carouselCreated[index].id;
        });

        cursosAreas[cursosIndex] = cursos;

        this.setState({ cursosAreas });
      });
  };

  handleCursosDropdownChange = (event, { value }) => {
    const { cursosAreas, cursosIndex } = this.state;

    cursosAreas[cursosIndex].dropdown.value = value;

    this.setState({ cursosAreas });
  };

  addCurso = () => {
    const { carousel, cursosAreas, cursosIndex } = this.state;
    const cursos = cursosAreas[cursosIndex];

    cursos.value = cursos.value.concat(cursos.dropdown.value);
    cursos.options = cursos.options.filter(
      (option) => !cursos.dropdown.value.includes(option.value)
    );
    carousel.size += cursos.dropdown.value.length;

    cursosAreas[cursosIndex] = cursos;

    this.setState({ cursosAreas, carousel });
  };

  removeCurso = (cardID) => {
    const { cursosAreas, cursosIndex, carousel } = this.state;
    const cursos = cursosAreas[cursosIndex];

    let foundCurso = -1;

    const delList = cursos.toBeDeleted.concat(
      cursos.value
        .filter((curso, index) => {
          if (curso.id == cardID) {
            delete this.nodeFaixa[curso.id];
            delete this.nodeInputFaixa[curso.id];

            foundCurso = index;

            return true;
          }
        })
        .map((curso, index) => {
          return curso.id_item;
        })
    );

    cursos.value.splice(foundCurso, 1);

    cursos.toBeDeleted = delList;
    carousel.size -= 1;

    cursosAreas[cursosIndex] = cursos;

    this.setState({ cursosAreas, cursosIndex, carousel });
  };

  showSwalModal = () => {
    swal({
      text: "Deseja salvar estas alterações dos carrosseis ?",
      button: "Sim",
    }).then((value) => {
      this.handleSalvarClick();
      swal(
        "Alterações salvas",
        "Suas alterações foram salvas no banco de dados da Voitto",
        "success",
        {
          button: "Entendi",
        }
      );
    });
  };

  handleSelect = (id_curso) => {
    const dadosCursoSelecionado = this.state.listAllCourses.filter(
      (item) => parseInt(item.key) === parseInt(id_curso)
    );

    this.setState({
      cursoUltimoAdicionado: {
        id_curso: dadosCursoSelecionado[0].key,
        url_amigavel: dadosCursoSelecionado[0].value.url_amigavel,
        title: dadosCursoSelecionado[0].text,
      },
    });
  };

  showSpecialOfferSwal = () => {
    swal({
      text: "Deseja salvar estas alterações nas ofertas especiais ?",
      button: "Sim",
    }).then((value) => {
      this.saveSpecialOffer();
      swal(
        "Alterações salvas",
        "Suas alterações foram salvas no banco de dados da Voitto",
        "success",
        {
          button: "Entendi",
        }
      );
    });
  };

  saveSpecialOffer = () => {
    producaov2.put(
      "/admin/ultimo_adicionado",
      { id_curso: this.state.cursoUltimoAdicionado.id_curso },
      {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      }
    );
  };

  render() {
    const {
      carrosseis,
      cursosAreas,
      cursosIndex,
      isLoading,
      carousel,
    } = this.state;

    if(cursosAreas[cursosIndex]) {
      return (
        <div style={{padding: "0 1.5rem"}}>
          <Container id="painel-carrosseis_corpo">
            <LoadScreen isLoading={isLoading} text="Carregando Carrosseis ..." />
  
            <Breadcrumb
              icon="right angle"
              sections={[
                {
                  key: "painel_controle",
                  content: "Painel de Controle",
                  link: true,
                  href: "/admin",
                  style: { fontSize: "0.78571429rem", color: "black" },
                },
                {
                  key: "carrosseis_meus_cursos",
                  content: "Painel de Carrosseis",
                  active: true,
                  style: { fontSize: "0.78571429rem", color: "black" },
                },
              ]}
            />
  
            <h1>Painel de Carrosseis</h1>
  
            <h3 id="painel-carrosseis_area-carousel-title">Área do Carrossel:</h3>
  
            <Container id="painel-carrosseis_menu-carousel">
              <Dropdown
                id="painel-carrosseis_carrosseis"
                name="carrosseis"
                placeholder="Carrossel"
                search
                fluid
                selection
                options={carrosseis.options}
                onChange={this.changeCarrosseisIndex}
                value={carrosseis.value}
              />
  
              {/*Botao que reordenava os carrosseis*/}
              {/* <ModalCarrosseisOrdenation
                carrosseis={carrosseis}
                handleOptionDragEnd={this.handleOptionDragEnd}
              /> */}
            </Container>
  
            <Container id="painel-carrosseis_area-carousel">
              <CarouselDragNDrop
                cursos={cursosAreas[cursosIndex]}
                carousel={carousel}
                removeCurso={this.removeCurso}
              />
  
              <ModalAdicionarCurso
                cursos={cursosAreas[cursosIndex]}
                addCurso={this.addCurso}
                handleCursosDropdownChange={this.handleCursosDropdownChange}
              />
            </Container>
  
            <div id="painel-carrosseis_area-salvar-carousel">
              <Button
                id="painel-carrosseis_salvar"
                positive
                onClick={this.showSwalModal}
              >
                Salvar
              </Button>
            </div>
          </Container>
          <Container>
            <Container>
              <h1>Seleção Oferta Especial</h1>
              <h2
                style={{ display: "block", margin: "20px 0px", fontSize: "18px" }}
              >
                Oferta Especial atualmente selecionada :
              </h2>
              <div>
                <h3
                  style={{
                    display: "block",
                    margin: "22px 0px",
                    textDecoration: "underline",
                  }}
                >
                  {this.state.cursoUltimoAdicionado.title}
                </h3>
                <img
                  class="ui centered medium image"
                  src={`https://files.voitto.com.br/cursos/small/${this.state.cursoUltimoAdicionado.url_amigavel}.jpg`}
                />
              </div>
              <select
                onChange={(e) => this.handleSelect(e.target.value)}
                value={this.state.cursoUltimoAdicionado.id_curso}
                style={{
                  display: "block",
                  margin: "36px auto",
                  width: "80%",
                  fontSize: "16px",
                  border: "solid 2px #000",
                  borderRadius: "8px",
                  cursor: "pointer",
                  padding: "4px",
                }}
              >
                {this.state.listAllCourses.map((item, key) => (
                  <option key={key} value={parseInt(item.value.id)}>
                    {item.text}
                  </option>
                ))}
              </select>
            </Container>
            <div>
              <Button positive onClick={(e) => this.showSpecialOfferSwal()}>
                Salvar
              </Button>
            </div>
          </Container>
        </div>
      );
    }
    return  <LoadScreen isLoading={isLoading} text="Carregando Carrosseis ..." />

  }
}
